import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import * as _ from 'lodash';

import { MessageEvent, SidemenuToCalendarEvent, ConfirmationPopup, HiddenFooter } from './../../shared/message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { PrimecalendarService } from './../primecalendar.service';
import { AppService } from '../../app.service';
import { LoaderEvent, OpenFrameEvent } from './../../shared/message.event';
import { UtilityFunctions } from '../../shared/utility-functions';
import { Invoice } from '../Invoice';

@Component({
  selector: 'app-view-summary',
  templateUrl: './view-summary.component.html',
  styleUrls: ['./view-summary.component.css'],
  providers: [PrimecalendarService, MessageEvent, LoaderEvent, OpenFrameEvent, ConfirmationPopup],
  exportAs: 'viewSummary'
})
export class ViewSummaryComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private stringConstants = CONSTANT_MESSAGES;
  private bookingData = [];
  private facilityData;
  private vendor;
  private shouldSlide: boolean = false;
  //private paymentfilter = 'All';
  private bookingDate;
  private unitName;
  private facilityType = CONSTANT_VALUES.FACILITY_TYPE;
  private timings = CONSTANT_VALUES.TIMINGS;
  private endTimeList = CONSTANT_VALUES.TIMINGS_END;
  private facilityList;
  private startTime;
  private endTime;
  private facility;
  private facilityName;
  private popUpMessage = '';
  private actionOnBookingObj = {};
  @Output() deleteBookingEmitter = new EventEmitter<any>();
  @Output() bookingByFacility = new EventEmitter<boolean>();
  private openTime;
  private closeTime;
  private utilityFunctions = new UtilityFunctions();
  private timezoneOffset;
  private showIconFlag = true;
  private bookingStart;
  private bookingEnd;
  private actionBooking;
  private displayBookingDate;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 25;
  private booking = 80;
  private unblockdate = 80;
  private divHeight = 0;
  private height: any;
  private scrollOptions: ISlimScrollOptions;
  private bookingPopupMessage = '';
  private disableNewBookingsForSuperAdmin = false;
  private isMarkAsVisitedDisabled = true;
  private isCurrentDate = false;
  private isWalkinBookingsClicked;
  private popup;
  private navigatePage = '';
  private hideAction = true;
  private isShowMarkAsVisited = false;
  private selectedFacility = '';
  private errorClass = '';
  private unitNames;
  private selectedActivityAll;
  private fetchBookingEndDate;
  private exp;
  private searchMember = '';
  private filterArray = [];
  private filterCriteriaArray;
  private maintainedFilter = [];
  private selectAllBookingFlag;
  private isopen1 = false;
  private isopen2 = false;
  private isopenPaymentMethodDropDown = false;
  private clickBookingOneTime = false;
  private invalidBookingDate = '';
  /*After booking unit changes  */

  private openTime_hours;
  private openTime_minutes;
  private closeTime_hours;
  private closeTime_minutes;
  private ActivityStartTimeHoursList = [];
  private ActivityEndTimeHoursList = [];
  private hours_value = CONSTANT_VALUES.HOUR_VALUES;
  private minutes_value = CONSTANT_VALUES.MINUTE_VALUES;
  private paymentDoneMessage = '';
  private paymentMethods = ['Vendor', 'Mobile', 'Booking pending', 'No charges', 'All'];
  private paymentMethod = 'All';
  constructor(private loaderEvent: LoaderEvent, private router: Router, private messageEvent: MessageEvent, private sidemenuToCalendarEvent: SidemenuToCalendarEvent, private appService: AppService, private calendarService: PrimecalendarService, private openFrameEvent: OpenFrameEvent, private confirmationPopup: ConfirmationPopup, private hiddenFooter: HiddenFooter) {
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.unblockdate + this.booking)) + 'px';
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
  }


  public hideChildModal(): void {
    this.childModal.hide();
  }


  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }
  ngOnInit() {
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.timezoneOffset = this.vendor.timezoneOffset * -1;
    }
    if (!this.bookingData) {
      this.router.navigate(['/calendar']);
    }
    this.exp = false;
    this.getFacility();

    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
    this.emitOpenFrameEvent();
    this.makeListForTime();
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      this.disableNewBookingsForSuperAdmin = true;
    }
    this.selectAllBookingFlag = false;
    this.hideActionButtons();
    this.setEndBookingDate();
    this.filterCriteriaArray = CONSTANT_VALUES.BOOKING_STATUS;
    this.clickBookingOneTime = false;
    this.paymentDoneMessage = '';
  }

  makeListForTime() {
    this.ActivityStartTimeHoursList = this.utilityFunctions.makeListForTime(this.facility, true)[0];
    this.ActivityEndTimeHoursList = this.utilityFunctions.makeListForTime(this.facility, true)[1];
  }


  getFacility() {
    let that = this;
    that.facilityList = [];
    let selectedFacility = JSON.parse((localStorage.getItem('summaryViewRequest'))) ? JSON.parse((localStorage.getItem('summaryViewRequest'))) : {};
    let facilityData = [];
    if (localStorage.getItem('vendor_facilityData')) {
      facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
    }
    facilityData.forEach(data => {
      data.data.forEach(facility => {
        that.facilityList.push(facility);
        if (!that.facility) {
          that.facility = facility._id === selectedFacility.facilityId || facility._id === selectedFacility._id ? facility : '';
          that.selectedFacility = that.facility;
        }
      });
    });
    if (that.facilityList.length > 1) {
      that.facilityList.push({ name: 'All' });
    }
    this.getDefaultBookings();
  }

  getAllFacilitiesId() {
    let that = this;
    let facilityIdsList = [];
    for (let data of this.facilityList) {
      if (data._id !== undefined) {
        facilityIdsList.push(data._id);
      }
    }
    return facilityIdsList;
  }

  facilityChange(item, walkinBookingPopUpObj) {
    this.selectedFacility = item;
    this.facilityData.unitNames = [];
    if (this.selectedFacility === "") {
      this.errorClass = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
    } else if (this.selectedFacility['name'] === "All") {
      this.errorClass = '';
      this.facilityData.unitNames.push('All');
      this.unitName = 'All';
      this.ActivityStartTimeHoursList = this.hours_value;
      this.ActivityEndTimeHoursList = this.hours_value;
    } else {
      this.errorClass = "";
      this.facility = _.cloneDeep(this.selectedFacility);
      this.ActivityStartTimeHoursList = [];
      this.ActivityEndTimeHoursList = [];
      if (this.facility.name !== 'All') {
        this.isopen2 = true;
        this.unitName = '';
        this.openTime = this.facility.timings.openTime.replace(/:00:00/g, '');
        this.openTime_hours = this.openTime.split(":")[0];
        this.openTime_minutes = this.openTime.split(":")[1];
        this.closeTime = this.facility.timings.closeTime.replace(/:00:00/g, '');
        this.closeTime_hours = this.closeTime.split(":")[0];
        this.closeTime_minutes = this.closeTime.split(":")[1];
        if (this.closeTime_hours == '23' && this.closeTime_minutes == '59') {
          this.closeTime_hours = '24';
          this.closeTime_minutes = '00'
        }
        this.facilityData.unitNames = this.facility.unitNames;
        this.makeListForTime();
      } else {
        this.facilityData.unitNames.push('All');
        this.unitName = 'All';
        this.unitName = 'All';
        this.openTime = '00:00';
        this.closeTime = '23:00';
        this.isopen2 = false;
      }
      if (this.facilityData.unitNames.length > 1) {
        this.facilityData.unitNames.push('All');
      } else {
        this.unitName = this.facilityData.unitNames[0];
        this.isopen2 = false;
        if (this.clickBookingOneTime && this.selectedFacility['name'] != "All") {
          let that = this;
          setTimeout(function () {
            walkinBookingPopUpObj.showChildModal(that.unitName);
          }, 100);

        }
      }
    }
  }

  getDefaultBookings() {
    this.facilityData = JSON.parse((localStorage.getItem('summaryViewRequest'))) ? JSON.parse((localStorage.getItem('summaryViewRequest'))) : {};
    let timeZoneDate, year, month, date, day, hour, minutes;
    if (this.facilityData) {
      localStorage.setItem('facilityIdOnViewSummary', (JSON.stringify({ 'facilityId': this.facilityData.facilityId, 'category': this.facilityData.category, unitName: this.facilityData.unitName, calendarDate: this.facilityData.calendarDate, filter: this.facilityData.filter, calendarView: this.facilityData.calendarView })));
      this.isShowMarkAsVisited = this.facilityData.isShowMarkAsVisited;
      if (this.facilityData.eventDate) {
        this.openTime = this.facilityData.facilityEventStart;
        this.openTime_hours = ('0' + this.openTime.split(":")[0]).slice(-2);
        this.openTime_minutes = ('0' + this.openTime.split(":")[1]).slice(-2);
        this.closeTime = this.facilityData.facilityEventEnd;
        this.closeTime_hours = ('0' + this.closeTime.split(":")[0]).slice(-2);
        this.closeTime_minutes = ('0' + this.closeTime.split(":")[1]).slice(-2);
        if (this.closeTime_hours == '23' && this.closeTime_minutes == '59') {
          this.closeTime_hours = '24';
          this.closeTime_minutes = '00';
          this.facilityData.facilityEventEnd = '24:00';
        }

        this.bookingStart = moment(this.facilityData.eventStart).utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
        this.bookingEnd = moment(this.facilityData.eventStart).utcOffset(this.timezoneOffset).utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
        this.unitName = this.facilityData.unitName;
        this.fetchBookingData(this.facilityData.facilityId, this.unitName, this.bookingStart, this.bookingEnd, this.facilityData.isChargeable);
        timeZoneDate = moment(this.facilityData.eventDate).utcOffset(this.timezoneOffset);
        year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
        this.bookingDate = (new Date(year, month, date, hour, minutes));
        this.displayBookingDate = timeZoneDate.format('MM/DD/YYYY');
      } else {
        this.openTime = _.cloneDeep(this.facilityData.facilityStart);
        this.openTime_hours = this.openTime.split(":")[0];
        this.openTime_minutes = this.openTime.split(":")[1];
        this.closeTime = this.facilityData.facilityEnd;
        this.closeTime_hours = this.closeTime.split(":")[0];
        this.closeTime_minutes = this.closeTime.split(":")[1];
        if (this.closeTime_hours == '23' && this.closeTime_minutes == '59') {
          this.closeTime_hours = '24';
          this.closeTime_minutes = '00'
        }
        this.bookingStart = moment().utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
        this.bookingEnd = moment().utcOffset(this.timezoneOffset).add(6, 'days').utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
        if (this.facilityData.unitNames.length > 1) {
          this.facilityData.unitNames.push('All');
          this.unitName = 'All';
        } else {
          this.unitName = this.facilityData.unitNames[0];
        }
        timeZoneDate = moment().utcOffset(this.timezoneOffset);
        year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
        this.bookingDate = (new Date(year, month, date, hour, minutes));
        this.fetchBookingData(this.facilityData.facilityId, this.unitName, this.bookingStart, this.bookingEnd, this.facilityData.isChargeable);
      }
    }
  }

  ngOnDestroy() {
    localStorage.removeItem('viewBookingData');
    localStorage.removeItem('needPopup');
  }

  /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster
     */
  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(bool => {
        this.shouldSlide = bool;
      });
  }

  setUnitName() {
  }

  cancelBooking(event, popUpObj) {
    let that = this;
    if (event) {
      let bookingObj = {
        'bookingId': this.actionBooking.bookingId,
        '_id': this.actionBooking._id, //user id
        'isFromVendor': true
      };
      this.loaderEvent.fire(false);
      this.calendarService.cancelBooking(bookingObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          that.fetchBookingData(this.selectedActivityAll === 'All' ? '' : this.selectedFacility['_id'], this.unitName, that.bookingStart, that.bookingEnd, this.selectedActivityAll === 'All' ? false : that.selectedFacility['isChargable']);
          this.loaderEvent.fire(true);
        }
        else {
          this.popUpMessage = result.message;
          this.loaderEvent.fire(true);
          popUpObj.showChildModal();
        }
      });
      this.actionOnBookingObj = {};
    } else {
    }
  }

  workAround() {
    const T = document.getElementsByClassName('table-tr');
    for (var a = 0; a < T.length; a++) {
      let ele: any = T[a];
      //ele.style.borderBottom = "1px solid grey";
      ele.style.borderWidth = "1px";
    }
    //setTimeout(this.other, 0);
  };

  showConfirmationPopup(popUpObj, item) {
    this.actionBooking = item;
    this.popUpMessage = CONSTANT_MESSAGES.CANCEL_BOOKING;
    popUpObj.showChildModal();
  }

  showConfirmationPopupForPayment(popUpObj, bookingPaymentObj) {
    this.clickBookingOneTime = false;
    this.actionBooking = bookingPaymentObj;
    this.popUpMessage = CONSTANT_MESSAGES.MAKE_PAYMENT;
    popUpObj.showChildModal();
  }

  show(bookingObj?) {
    if (bookingObj) {
      this.deleteBookingEmitter.emit(bookingObj);
    } else {
    }
  }

  makePaymentForBooking(event, popUpObj) {
    if (event) {
      if (this.actionBooking && !this.actionBooking.isPaymentDone) {
        let that = this;
        let paymentObj = {
          'bookingId': this.actionBooking['bookingId'],
          '_id': this.actionBooking['_id'],
          'vendorId': this.vendor['_id'],
          payAt: this.actionBooking['facilityCharges'] == 0 ? 'no charges' : 'vendor'
        };
        this.loaderEvent.fire(false);
        this.calendarService.makePayment(paymentObj).then((result: any) => {
          if (result.status === 'SUCCESS') {
            that.fetchBookingData(this.selectedActivityAll === 'All' ? '' : this.selectedFacility['_id'], this.unitName, that.bookingStart, that.bookingEnd, this.selectedActivityAll === 'All' ? false : that.selectedFacility['isChargable']);
            this.loaderEvent.fire(true);
          } else {
            this.popUpMessage = result.message;
            this.loaderEvent.fire(true);
            popUpObj.showChildModal();
          }
        });
      } else {
      }

    } else {
    }
  }

  fetchBookingData(facilityId, unitName, startTime, endTime, isChargeable) {
    let that = this;
    let facilityObj;
    let facilityIds = [];
    let currentDateForPayment;
    if (facilityId !== '') {
      facilityIds.push(facilityId);
    } else {
      let facilityIdsList = this.getAllFacilitiesId();
      facilityIds = facilityIdsList;
    }

    let fetchEndTime = this.closeTime_hours + ":" + this.closeTime_minutes;
    fetchEndTime = fetchEndTime == '24:00' ? '23:59' : fetchEndTime;
    let requestObj = {
      facilityIds: facilityIds,
      unitName: unitName && unitName != 'All' && this.facility.unitNames.length > 1 ? unitName : '',
      startDate: startTime,
      endDate: endTime,
      startTime: this.openTime_hours + ":" + this.openTime_minutes,
      endTime: fetchEndTime,
      //endTime = endTime == '24:00' ? '23:59' : endTime
      //aish
      vendorId: '',
      timezoneOffset: this.timezoneOffset * -1,
      filters: [],
      paymentMethods: this.paymentMethod == 'All' ? ['vendor', 'mobile', 'booking pending', 'no charges'] : [this.paymentMethod.toLocaleLowerCase()]
    };
    // if (!this.facilityData.isChargeable) {
    //   delete requestObj.paymentMethods;
    // }
    let bookingTime;
    let currentDate = moment().utcOffset(that.timezoneOffset);
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        requestObj.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      requestObj.vendorId = this.vendor.vendorId;
    } else {
      requestObj.vendorId = this.vendor._id;
    }
    if (this.filterArray) {
      requestObj.filters = JSON.parse(JSON.stringify(this.filterArray));
    }
    if (this.searchMember) {
      requestObj.filters.push({
        type: 'search',
        values: this.searchMember
      });
    } else {
      _.remove(this.filterArray, function (n) {
        return n.type === 'search';
      });
    }
    that.loaderEvent.fire(false);
    this.calendarService.getCourtWiseBookings(requestObj).then((result: any) => {
      if (result.status === 'SUCCESS') {
        that.bookingData = result.bookingData;
        that.bookingData = that.bookingData.filter(function (rec) {
          rec.status = rec.bookingStatus;
          bookingTime = moment(rec.startTime).utcOffset(that.timezoneOffset);
          rec.showIconToCancel = bookingTime < currentDate || that.vendor.role.indexOf(CONSTANT_VALUES.SUPER_ADMIN) >= 0 ? false : true;
          currentDateForPayment = moment().utcOffset(that.timezoneOffset).startOf('day');
          rec.showIcontoMakePayment = bookingTime.isBefore(currentDateForPayment) ? false : true;

          if (rec.checkInTime) {
            rec.checkInTime = moment(rec.checkInTime).utcOffset(that.timezoneOffset).format('HH:mm');
            rec.isCheckInTimeEnabled = false;
            rec.checkedInTime = true;
            if (rec.checkOutTime) {
              rec.checkOutTime = moment(rec.checkOutTime).utcOffset(that.timezoneOffset).format('HH:mm');
              rec.checkedOutTime = true;
              rec.isCheckOutTimeEnabled = false;
            } else {
              rec.isCheckOutTimeEnabled = rec.isActive ? !that.checkInOutDesable(bookingTime) : false;
            }
          } else {
            rec.isCheckInTimeEnabled = true;
          }
          facilityObj = that.findFacilityName(rec.facilityId);
          rec.facilityCharges = facilityObj.activityCharges;
          if (facilityObj.isChargable && rec.isPaymentDone === false && rec.bookingStatus === 'booked' && rec.bookingConfirmed) {
            rec.status = 'Booking Pending'
            rec.showPaymentIcon = true;
          } else {
            rec.showPaymentIcon = false;
          }
          if (rec.isWalkInBooking) {
            rec.walkInStateClass = 'walkin-status';
            rec.state = 'Walk In';
          } else {
            rec.walkInStateClass = '';
            rec.state = '';
          }

          if (!rec.isActive) {
            rec.status = 'Cancelled';
            rec.walkInStateClass = '';
            rec.showIcontoMakePayment = false;
            rec.showIconToCancel = false;
            rec.isCheckInTimeEnabled = false;
          }
          rec.bookingDate = moment(rec.startTime).utcOffset(that.timezoneOffset).format('ll');
          if (rec.deletedAt) {
            let deletedAtDate = rec.deletedAt;
            rec.deletedAtTime = moment(deletedAtDate).utcOffset(that.timezoneOffset).hour();
            rec.deletedAtTimeMinutes = moment(deletedAtDate).utcOffset(that.timezoneOffset).minutes();
            rec.deletedAtTimeMinutes = rec.deletedAtTimeMinutes < 10 ? "0" + rec.deletedAtTimeMinutes : rec.deletedAtTimeMinutes;
            rec.deletedAtTime = rec.deletedAtTime < 10 ? "0" + rec.deletedAtTime + ":" + rec.deletedAtTimeMinutes : rec.deletedAtTime + ":" + rec.deletedAtTimeMinutes;
            rec.deletedAt = moment(rec.deletedAt).utcOffset(that.timezoneOffset).format('ll');

          }
          //start time
          let startHours = moment(rec.startTime).utcOffset(that.timezoneOffset).hour();
          let startMinutes = moment(rec.startTime).utcOffset(that.timezoneOffset).minutes();
          rec.startMinutes = startMinutes < 10 ? "0" + startMinutes : startMinutes;
          //hours + minutes
          rec.start = startHours < 10 ? "0" + startHours : startHours;
          rec.start = rec.start + ':' + rec.startMinutes;

          //end time
          let endHours = moment(rec.endTime).utcOffset(that.timezoneOffset).hour();
          let endMinutes = moment(rec.endTime).utcOffset(that.timezoneOffset).minutes();
          rec.endMinutes = endMinutes < 10 ? "0" + endMinutes : endMinutes;
          rec.end = moment(rec.endTime).utcOffset(that.timezoneOffset).hour();
          //hour + minutes
          rec.end = endHours < 10 ? "0" + endHours : endHours;
          rec.end = rec.end + ":" + rec.endMinutes;
          if (rec.end == "23:59") {
            rec.end = "24:00"
          }
          rec.statusClass = that.getStatusClass(rec.status);
          rec.facilityName = facilityObj ? facilityObj.facilityName : '';
          rec.ismarkAsVisited = facilityObj ? facilityObj.markAsVisited : '';
          if (that.checkInOutDesable(bookingTime)) {
            rec.isCheckInTimeEnabled = false;
          }
          /*if (rec.bookingStatus === 'waitlist') {
            rec.isCheckInTimeEnabled = false;
            rec.isCheckOutTimeEnabled = false;
          }*/

          // if(rec.bookingStatus === 'waitlist' && !rec.bookingConfirmed){
          //   rec.status = 'Confirmation Pendting'
          // }

          if (that.vendor.allowPayment && rec.facilityCharges == 0 && rec.status == 'Booking Pending') {
            rec.paymentMethod = 'No charges'
          }
          return rec;
        });
        setTimeout(that.workAround.bind(that), 500);
        setTimeout(function () {
          that.loaderEvent.fire(true);
        }, 600);
      } else {
        that.loaderEvent.fire(true);
      }
    });
  }

  homeScreen() {
    let flag = true;
    for (let data of this.bookingData) {
      if (this.isWalkinBookingsClicked === false && data.checkInTime) {
        this.popUpMessage = 'Your changes will be lost. Do you want to continue!!';
        if (this.popup) {
          this.navigatePage = 'member';
          this.popup.showChildModal();
          flag = false;
          break;
        }
      }
    }
    if (flag) {
      this.utilityFunctions.homeScreen(this);
    }
  }

  closeSummaryPopup() {
    this.router.navigate(['/calendar']);
  }

  ApplyBookingFilters(popUpObj?) {
    this.clickBookingOneTime = false;
    this.invalidBookingDate = ''
    if (this.bookingStart.isBefore(this.bookingEnd)) {
      this.invalidBookingDate = ''
      localStorage.removeItem('needPopup');
      this.isMarkAsVisitedDisabled = true;
      this.bookingData = [];
      let isChargable;
      if (!this.unitName) {
        this.unitName = 'All';
        //this.selectedActivityAll = 'All';
      }
      let selectedFacilityId = this.selectedFacility['_id'];
      if (this.selectedFacility['name'] === 'All') {
        selectedFacilityId = '';
        this.selectedActivityAll = 'All';
      } else {
        this.selectedActivityAll = '';
      }

      if (this.selectedFacility['name'] !== 'All') {
        isChargable = this.selectedFacility['isChargable'];
        this.isShowMarkAsVisited = this.selectedFacility['isShowMarkAsVisited'];
      } else {
        this.openTime = "00:00";
        this.closeTime = "23:00";
        isChargable = false;
        this.isShowMarkAsVisited = true;
      }

      if (this.openTime > this.closeTime) {
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_START_TIME_AND_END_TIME;
        popUpObj.showChildModal();
      }
      else if (this.openTime === this.closeTime) {
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_TIME_DURATION;
        popUpObj.showChildModal();
      } else {
        this.bookingStart = moment(this.bookingDate).utcOffset(this.timezoneOffset, true).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });

        if (!this.facilityData.eventDate) {
          this.bookingEnd = moment(this.fetchBookingEndDate).utcOffset(this.timezoneOffset, true).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
        }
        this.fetchBookingData(this.selectedActivityAll === 'All' ? '' : this.selectedFacility['_id'], this.unitName, this.bookingStart, this.bookingEnd, isChargable);
      }
    } else {

      if (popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MESSAGE;
        popUpObj.showChildModal();
      } else {
        this.invalidBookingDate = 'required'
      }
    }
  }

  timeConvert24to12(time) {
    let t = parseInt(time);
    if (isNaN(t)) return '00';
    if (t === 0) return '12 AM';
    else if (t === 12) return '12 PM';
    else if (t === 24) return '12 AM';
    else {
      let suffix = t > 12 ? ':00 PM' : ':00 AM';
      let prefix = t % 12 < 10 ? '0' : '';
      return prefix + t % 12 + suffix;
    }
  }

  newBookingsPopup(popUpObj, msgPopUp, newBookingsPopup) {
    this.clickBookingOneTime = true;
    if (!localStorage.getItem('needPopup')) {
      if (this.selectedFacility['name'] === 'All') {
        this.isopen1 = true;
      } else if (this.unitName === 'All' || this.unitName === '') {
        this.isopen2 = true;
      } else {
        popUpObj.showChildModal();
        this.clickBookingOneTime = false;
      }
    } else {
      this.popUpMessage = 'Your changes will be lost. Do you want to continue!!';
      newBookingsPopup.showChildModal();
    }
  }

  refreshPage(popupObj) {
    this.ApplyBookingFilters(popupObj);

  }

  showBlockDatePopup(showBlockDatePopup, popupObj) {
    this.clickBookingOneTime = false;
    if (localStorage.getItem('needPopup')) {
      this.popUpMessage = 'Your changes will be lost. Do you want to continue!!';
      popupObj.showChildModal();
    } else {
      showBlockDatePopup.showChildModal();
    }
  }

  showUnBlockDatePopup() {
    this.router.navigate(['/unblockslot'])
  }

  getStatusClass(status) {
    let statusClass = '';
    switch (status) {
      case 'booked': statusClass = 'booked-status'; break;
      case 'waitlist': statusClass = 'waitlist-status'; break;
      case 'Booking Pending': statusClass = 'payment-status'; break;
      case 'Cancelled': statusClass = 'cancelled'; break;
    }
    return statusClass
  }

  /* CheckIn and Checkout */

  checkIfCurrentDate() {
    let selectedBookingDate = moment(this.bookingDate).utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    let currentDate = moment().utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    if (selectedBookingDate.isSame(currentDate) === true) {
      this.isCurrentDate = true;
    } else {
      this.isCurrentDate = false;
    }
    this.disableCheckinCheckout();
  }

  disableCheckinCheckout() {
    if (!this.isCurrentDate || this.disableNewBookingsForSuperAdmin) {
      for (let data of this.bookingData) {
        data.isCheckInTimeEnabled = false;
        data.isCheckOutTimeEnabled = false;
      }
    }
  }

  displayCheckInTimeOnAction(e, item, popup) {
    this.clickBookingOneTime = false;
    this.popup = popup;
    localStorage.setItem('needPopup', 'true');
    if (!e.target.checked) {
      delete item['checkInTime'];
      delete item['checkOutTime'];
      item.isCheckOutTimeEnabled = false;
      item.checkedOutTime = false;
      let noCheckInTime = this.getAllCheckInTimeValues() || this.getAllCheckOutTimeValues();
      if (noCheckInTime === true) {
        this.isMarkAsVisitedDisabled = false;
      } else {
        this.isMarkAsVisitedDisabled = true;
        localStorage.removeItem('needPopup');
      }
    } else {
      let currentTime = moment().utcOffset(this.timezoneOffset).format('HH:mm');
      item.checkInTime = currentTime;
      item.isCheckOutTimeEnabled = true;
      this.isMarkAsVisitedDisabled = false;
      localStorage.setItem('needPopup', 'true');
    }
    this.isWalkinBookingsClicked = false;
  }

  getAllCheckInTimeValues() {
    let f = false;
    for (let data of this.bookingData) {
      if (data.checkInTime && data.isCheckInTimeEnabled) {
        f = true;
        break;
      }
    }
    return f;
  }

  displayCheckOutTimeOnAction(e, item) {
    this.clickBookingOneTime = false;
    if (e.target.checked) {
      let currentTime = moment().utcOffset(this.timezoneOffset).format('HH:mm');
      item.checkOutTime = currentTime;
      item.checkedOutTime = true;
      this.isMarkAsVisitedDisabled = false;
      localStorage.setItem('needPopup', 'true');
    } else {
      delete item['checkOutTime'];
    }
    if (this.getAllCheckOutTimeValues() || this.getAllCheckInTimeValues()) {
      this.isMarkAsVisitedDisabled = false;
    } else {
      this.isMarkAsVisitedDisabled = true;
      localStorage.removeItem('needPopup');
    }
  }

  getAllCheckOutTimeValues() {
    let f = false;
    for (let data of this.bookingData) {
      if (data.checkOutTime && data.isCheckOutTimeEnabled) {
        f = true;
        break;
      }
    }
    return f;
  }

  checkInTimeToServer(e, item) {
    let currentTime = moment().utcOffset(this.timezoneOffset).format('HH:mm');
    let checkInCheckoutTimings = [];
    if (e.target.checked) {
      item.checkInTime = currentTime;
      item.checkedInTime = true;
      item.isCheckInTimeEnabled = false;
      item.isCheckOutTimeEnabled = true;
      let checkinTime = moment().utcOffset(this.timezoneOffset).set({ 'hour': item.checkInTime.split(':')[0], 'second': 0, 'minute': item.checkInTime.split(':')[1], 'millisecond': 0 });

      checkInCheckoutTimings.push({
        'bookingId': item.bookingId,
        'userId': item._id,
        'checkInTime': item.checkInTime ? checkinTime.toISOString() : '',
        'checkOutTime': item.checkOutTime ? item.checkOutTime : ''
      });
      this.markBookingsAsVisited(checkInCheckoutTimings, item);
    }
  }

  checkOutTimeToServer(e, item) {
    let currentTime = moment().utcOffset(this.timezoneOffset).format('HH:mm');
    let checkInCheckoutTimings = [];
    if (e.target.checked) {
      item.checkOutTime = currentTime;
      item.checkedOutTime = true;
      item.isCheckOutTimeEnabled = false;
      let checkinTime = moment().utcOffset(this.timezoneOffset).set({ 'hour': item.checkInTime.split(':')[0], 'second': 0, 'minute': item.checkInTime.split(':')[1], 'millisecond': 0 });
      let checkoutTime = moment().utcOffset(this.timezoneOffset).set({ 'hour': item.checkOutTime.split(':')[0], 'second': 0, 'minute': item.checkOutTime.split(':')[1], 'millisecond': 0 });
      checkInCheckoutTimings.push({
        'bookingId': item.bookingId,
        'userId': item._id,
        'checkInTime': item.checkInTime ? checkinTime.toISOString() : '',
        'checkOutTime': item.checkOutTime ? checkoutTime.toISOString() : ''
      });
      this.markBookingsAsVisited(checkInCheckoutTimings, item);
    }
  }

  /*getAllCheckedTimes(event, popUpObj) {
    if (event) {
      this.isWalkinBookingsClicked = true;

      let timeData = {
        checkInTime: '',
        checkOutTime: ''
      };
      let checkInCheckoutTimings = [];
      this.loaderEvent.fire(false);
      for (let data of this.bookingData) {
        timeData = {
          checkInTime: '',
          checkOutTime: ''
        };
        if (data.isCheckOutTimeEnabled === true) {
          if (data.checkInTime) {
            let checkinTime = moment().utcOffset(this.timezoneOffset).set({ 'hour': data.checkInTime.split(':')[0], 'second': 0, 'minute': data.checkInTime.split(':')[1], 'millisecond': 0 });
            timeData.checkInTime = checkinTime.toISOString()
            if (data.checkOutTime) {
              let checkOutTime = moment().utcOffset(this.timezoneOffset).set({ 'hour': data.checkOutTime.split(':')[0], 'second': 0, 'minute': data.checkOutTime.split(':')[1], 'millisecond': 0 });
              timeData.checkOutTime = checkOutTime.toISOString();
            }
            checkInCheckoutTimings.push({
              'bookingId': data.bookingId,
              'userId': data._id,
              'checkInTime': timeData.checkInTime ? timeData.checkInTime : '',
              'checkOutTime': timeData.checkOutTime ? timeData.checkOutTime : ''
            });
          }
        }
      }
      this.markBookingsAsVisited(checkInCheckoutTimings, popUpObj);
    }
  }*/

  markBookingsAsVisited(Obj, item, popUpObj?) {

    let markBookingsAsVisitedObj = {
      vendorId: this.vendor.role === CONSTANT_VALUES.ROLE_STAFF ? this.vendor.vendorId : this.vendor._id,
      bookings: Obj,
      feedbackUrl: this.vendor.feedbackUrl ? this.vendor.feedbackUrl : '',
      userId: item._id,
      clubName: this.vendor.clubName,
      contactNumber: item.contactNumber,
      emailId: item.emailId,
      firstName: item.firstName
    }

    this.calendarService.markBookingsAsVisited(markBookingsAsVisitedObj).then((result: any) => {
      // this.bookingPopupMessage = result.message;
      //this.loaderEvent.fire(true);
      //popUpObj.showChildModal();
      // this.isMarkAsVisitedDisabled = true;
      // this.isWalkinBookingsClicked = false;
    });
  }

  checkInOutDesable(bookingDate) {
    let currentDate = moment().utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    let bookingDateForCheck = moment(bookingDate).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    if (currentDate.isSame(bookingDateForCheck)) {
      return false;
    } else {
      return true;
    }
  }
  showAdditionalInformationPopup(popUpObj, item) {
    popUpObj.showChildModal(item, this.timezoneOffset);
  }

  hideActionButtons() {
    this.hideAction = this.facilityData.isAllowMemberNotes || this.showIconFlag;
  }

  confirmationForBlock(event, popupObj) {
    if (event) {
      localStorage.removeItem('needPopup');
      this.refreshPage(popupObj);
      let that = this;
      setTimeout(function () {
        popupObj.showChildModal();
      }, 800);
    } else {
      console.log('please check your data');
    }
  }

  findFacilityName(facilityId) {
    let facility = _.find(this.facilityList, { _id: facilityId });
    return {
      facilityName: facility['name'],
      markAsVisited: facility['isShowMarkAsVisited'],
      isChargable: facility['isChargable'],
      activityCharges: facility['amount']['value'],
      isGSTApplicable: facility['isGSTApplicable'],
      GSTValue: facility['GSTValue'],
      facilityTimezoneOffset: facility['timezoneOffset'],
      timezoneAbbr: facility['timezoneAbbr'],
      currency: facility['amount']['currency'],
      slotDuration: facility['slotDuration']
    }
  }

  setEndBookingDate() {
    let bookingEndDate = moment().add(5, 'days').utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
    let year = bookingEndDate.year(), month = bookingEndDate.month(), date = bookingEndDate.date(), hour = bookingEndDate.hour(), minutes = bookingEndDate.minutes();
    this.fetchBookingEndDate = (new Date(year, month, date, hour, minutes));
  }

  setBookingStartDate(bookingStartDate) {
    this.clickBookingOneTime = false;
    this.bookingStart = moment(bookingStartDate).utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
  }

  setBookingEndDate(bookingEndTime) {
    this.clickBookingOneTime = false;
    this.bookingEnd = moment(bookingEndTime).utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 })
  }

  expand() {
    this.clickBookingOneTime = false;
    if ((this.searchMember + '').trim()) {
      this.ApplyBookingFilters();
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.ApplyBookingFilters();
      }
      this.exp = !this.exp;
    }
  }

  setFilterCriteria(e, item) {
    if (e.target.checked) {
      this.filterArray.push(item);
    } else {
      _.remove(this.filterArray, function (n) {
        return n.type === item.type;
      });
    }
  }

  applyFilter() {
    if (this.filterArray) {
      this.ApplyBookingFilters();
    }
  }

  resetFilterArray() {
    this.clickBookingOneTime = false;
    this.filterArray = JSON.parse(JSON.stringify(this.maintainedFilter));
    for (let l = 0; l < this.filterCriteriaArray.length; l++) {
      if (_.find(this.maintainedFilter, { type: this.filterCriteriaArray[l]['type'] })) {
        this.filterCriteriaArray[l]['isChecked'] = true;
      } else {
        this.filterCriteriaArray[l]['isChecked'] = false;
      }
    }
  }

  maintainStateOfFilter() {
    this.maintainedFilter = JSON.parse(JSON.stringify(this.filterArray));
  }

  printViewSummary() {
    this.clickBookingOneTime = false;
    window.print();
  }

  addAllBookingForAction(e) {
    if (e.target.checked) {
      this.bookingData.forEach(element => {
        element.selectAllBookingFlag = true;
      });
    } else {
      this.bookingData.forEach(element => {
        element.selectAllBookingFlag = false;
      });
    }
  }

  handleSelectAllBookings(e) {
    if (e.target.checked) {
      if (_.find(this.bookingData, { selectAllBookingFlag: false })) {
        this.selectAllBookingFlag = false;
      } else {
        this.selectAllBookingFlag = true;
      }
    } else {
      this.selectAllBookingFlag = false;
    }
  }

  deleteMultipleBookings(popUpObj) {
    let bookingsForDelete = [];
    this.bookingData.forEach(element => {
      bookingsForDelete.push({
        '_id': element._id,
        'bookingId': element.bookingId,
        'status': element.bookingStatus,
        'isActive': element.isActive
      });
    });
    let req = {
      "vendorId": this.vendor._id,
      "bookings": bookingsForDelete
    }
    let that = this;
    this.loaderEvent.fire(false);
    this.calendarService.multipleDeleteBookings(req).then((result: any) => {
      if (result.status === 'SUCCESS') {
        that.fetchBookingData(this.selectedActivityAll === 'All' ? '' : this.selectedFacility['_id'], this.unitName, that.bookingStart, that.bookingEnd, this.selectedActivityAll == 'All' ? false : that.selectedFacility['isChargable']);
        this.loaderEvent.fire(true);
      } else {
        this.popUpMessage = result.message;
        this.loaderEvent.fire(true);
        popUpObj.showChildModal();
      }
    });
  }

  changeUnitName(item, walkinBookingPopUpObj) {
    this.unitName = item;
    if (this.clickBookingOneTime && this.unitName != 'All') {
      walkinBookingPopUpObj.showChildModal(this.unitName);
    }
  }
  setMinutes(hourVal, that, min) {
    this.utilityFunctions.setMinutes(hourVal, that, min);
  }

  showInvoice(viewInvoice, bookingData) {
    this.loaderEvent.fire(false);
    let generatedInvoice;
    let facilityObj = this.findFacilityName(bookingData.facilityId);
    let bookingSlots = this.calculateNumberOfSlots(bookingData.startTime, bookingData.endTime, facilityObj['slotDuration']);
    let invoiceObj: Invoice = {
      userId: bookingData._id,
      bookingId: bookingData.bookingId,
      facilityId: bookingData.facilityId,
      unitName: bookingData.unitName,
      activityCharges: facilityObj.activityCharges,
      serviceId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
      isGSTApplicable: facilityObj.isGSTApplicable,
      GSTValue: facilityObj.GSTValue,
      noOfPeople: bookingData.attendees,
      noOfSlotsBooked: '',
      facilityTimezoneOffset: facilityObj.facilityTimezoneOffset,
      timezoneAbbr: facilityObj.timezoneAbbr,
      activityName: facilityObj['facilityName'],
      bookingSlots: bookingSlots,
      currency: facilityObj.currency,
    }
    this.calendarService.generateInvoice(invoiceObj).then((result: any) => {
      generatedInvoice = result.data;
      generatedInvoice.bookingId = bookingData.bookingId;
      generatedInvoice.userId = bookingData._id;
      generatedInvoice.vendorId = this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
        this.loaderEvent.fire(true);
      if (result.status == 'SUCCESS') {
        this.utilityFunctions.showInvoice(viewInvoice, generatedInvoice);
      } else {
      }
    });
  }

  calculateNumberOfSlots(bookingStartTime, bookingEndTime, slotDuration) {
    slotDuration = slotDuration == 1439 ? 1440 : slotDuration;
    const eventStart = moment(bookingEndTime).utcOffset(this.timezoneOffset);
    const eventEnd = moment(bookingStartTime).utcOffset(this.timezoneOffset)
    let duration = moment.duration(eventStart.diff(eventEnd));
    const durationInMin = duration.asMinutes();
    return durationInMin / slotDuration;
  }

  showpaymentpopup(pymentDonePopup, message) {
    this.paymentDoneMessage = message;
    pymentDonePopup.showChildModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/view-summary/view-summary.component.ts